import { dialogClasses, LinearProgress } from '@mui/material';
import { Box } from '@mui/system';

import Dialog from 'Lib/muiComponents/dialog/Dialog';

/**
 * Renders a dialog component for displaying a processing status.
 *
 * @param {string} [statusText='Processing...'] - The text to display as the processing status.
 * @param {string} [title=''] - The title of the dialog.
 * @param {boolean} open - Determines whether the dialog is open or not.
 * @param {Object} sx - Additional styles to apply to the dialog.
 * @returns {JSX.Element} The rendered ProcessingDialog component.
 */
export default function ProcessingDialog({ statusText = 'Processing...', title = '', open, sx }) {
    return (
        <Dialog
            open={open}
            title={title}
            maxWidth="xs"
            sx={{
                [`& .${dialogClasses.paper}`]: {
                    width: { xs: '100%', sm: '400px' },
                    height: { xs: '100%', sm: '224px' }
                },
                ...sx
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="100%"
                gap={6}
                sx={{ position: 'absolute', top: 0, left: 0, width: '100%' }}
            >
                <Box sx={theme => ({ fontSize: theme.typography.pxToRem(22) })}>{statusText}</Box>
                <LinearProgress upload="true" sx={{ width: '240px' }} />
            </Box>
        </Dialog>
    );
}
